module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/06_shape-lg-4f03f19832bea930676628013525d04c.png";